import Vue from 'vue';

// 1. 创建全局响应式单例
const globalMenuState = Vue.observable({
  custom_menu: (() => {
    try {
      const cache = localStorage.getItem('sys_menu_config_map');
      return cache ? JSON.parse(cache) : {};
    } catch (e) {
      return {};
    }
  })()
});

// 2. 监听跨标签页同步
window.addEventListener('storage', (event) => {
  if (event.key === 'sys_menu_config_map' && event.newValue) {
    try {
      globalMenuState.custom_menu = JSON.parse(event.newValue);
    } catch (e) {}
  }
});

// 3. 提供更新方法（当前标签页直接更新单例）
export function setCustomMenu(menuConfigStr) {
  try {
    const parsed = menuConfigStr ? JSON.parse(menuConfigStr) : {};
    globalMenuState.custom_menu = parsed;
    if (menuConfigStr) {
      localStorage.setItem('sys_menu_config_map', menuConfigStr);
    } else {
      localStorage.removeItem('sys_menu_config_map');
    }
  } catch (e) {
    // 解析失败，不更新
  }
}

// 4. 导出 Mixin
export const sysConfigMenuMixin = {
  computed: {
    custom_menu() {
      return globalMenuState.custom_menu;
    }
  }
};
